import { SelectOption } from "../../../types";

export const STEPS_NUMBER = 3;
export const SECOND_STEP_INDEX = 1;
export const BANKI_RU_PLATFORM_ID = 2;

export const AGREE_LINK =
  "https://bron.kamkombank.ru/web/uploads/Consent_Processing_Personal_Data.pdf";
export const YES_LINK = "https://review.kamkombank.ru/review/positive";
export const NO_LINK = "https://review.kamkombank.ru/";
export const REVIEW_TEMPLATES_LINK = "https://evoteka.ru/aotziv-examples/";
export const CONTACT_US_LINK =
  "https://max.ru/u/f9LHodD0cOJfrSypOSZrbkzUE-NkA2_eM-rD5R4GF_D5ELcd3Gzz2-b8y68?bar=1";

export const CITY_FIELD_NAME = "city";
export const CITY_POINT_FIELD_NAME = "cityPoint";
export const REFILL_FIELD_NAME = "refill";
export const BANK_FIELD_NAME = "bank";

export const cities: SelectOption[] = [
  { label: "Москва", value: "Москва" },
  { label: "Санкт-Петербург", value: "Санкт-Петербург" },
  { label: "Казань", value: "Казань" },
  { label: "Набережные Челны", value: "Набережные Челны" },
  { label: "Альметьевск", value: "Альметьевск" },
  { label: "Ижевск", value: "Ижевск" },
];

export const replenishmentTypes: SelectOption[] = [
  // { label: "На баланс телефона", value: "На баланс телефона" },
  { label: "СБП", value: "СБП" },
];

export const REQUIREMENTS_TO_SCREENSHOT: string[] = [
  "Ваше имя (ник)",
  "Название Банка",
  "Оценка 5*",
  // "Дата и статус отзыва",
  "Содержание отзыва",
];

export const REQUIREMENTS_TO_REVIEW_LINK: string[] = [
  "Зайдите в личный кабинет на Банки.ру, раздел «Отзывы и вопросы» → «Мои отзывы»",
  "Откройте отзыв и скопируйте ссылку из адресной строки",
];

const BANKI_RU_COMMON_REQUIREMENTS = [
  { text: "Справка об операции (видна только модераторам Банки.ру)", type: "checked" },
  {
    text: "Дату и <b>точное время визита</b> (указано в справке), адрес офиса, фамилию сотрудника",
    type: "checked",
  },
  {
    text: "Описание процесса:<br />&nbsp;&nbsp;&nbsp;&nbsp;- Как прошло обслуживание и что понравилось<br />&nbsp;&nbsp;&nbsp;&nbsp;- Как именно помог сотрудник и на какие вопросы ответил<br />&nbsp;&nbsp;&nbsp;&nbsp;- Если был обмен по резерву - опишите процесс и консультацию оператора",
    type: "checked",
  },
  {
    text: "Актуальные контакты - возможен звонок с Банки.ру:<br />&nbsp;&nbsp;&nbsp;&nbsp;+7 495 665-52-55<br />&nbsp;&nbsp;&nbsp;&nbsp;+7 495 665-52-54",
    type: "checked",
  },
];

export const BANKI_RU_FIRST_STEP_REQUIREMENTS = [
  BANKI_RU_COMMON_REQUIREMENTS[0],
  { text: "<b>Проверьте, что в тексте отзыва есть:</b>", type: "text" },
  ...BANKI_RU_COMMON_REQUIREMENTS.slice(1),
];

export const BANKI_RU_FORM_SUCCESS_REQUIREMENTS = [
  BANKI_RU_COMMON_REQUIREMENTS[0],
  { text: "<b>В тексте отзыва пропишите:</b>", type: "text" },
  ...BANKI_RU_COMMON_REQUIREMENTS.slice(1),
];

export const BANKI_RU_STOP_LIST = [
  "Не копируйте чужие отзывы и не используйте нейросети",
  "Не указывайте ожидание в очереди > 15 мин",
];

export const BANKI_RU_FIRST_STEP_WARNING = [
  "Недостающую информацию нужно добавить в комментарии к отзыву - это важно для зачтения отзыва",
];

export const BANKI_RU_FORM_SUCCESS_WARNING = [
  "Сделайте скриншот этой страницы, чтобы ничего не забыть при написании отзыва!",
];
